import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { PainChecklist } from '../components/PainChecklist';
import { AgitationSection } from '../components/AgitationSection';
import { WhyTheyFail } from '../components/WhyTheyFail';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { OriginStory } from '../components/OriginStory';
import { ProductPresentation } from '../components/ProductPresentation';
import { ValueBreakdown } from '../components/ValueBreakdown';
import { OfferStack } from '../components/OfferStack';
import { Testimonials } from '../components/Testimonials';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    // Load Meta Pixel SDK
    if (typeof window !== 'undefined' && !window.fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      // noscript fallback
      const noscript = document.createElement('img');
      noscript.height = 1;
      noscript.width = 1;
      noscript.style.display = 'none';
      noscript.src = 'https://www.facebook.com/tr?id=1497007874735639&ev=PageView&noscript=1';
      document.body.appendChild(noscript);
    }
    // Init and track
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('init', '1497007874735639');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <main className="min-h-screen w-full pt-12" data-id="element-393">
      <StickyAlertBar data-id="element-394" />
      {/* 1. Hero - chocolate-900 (dark) */}
      <HeroSection data-id="element-395" />
      {/* 4. Pain Checklist - white */}
      <PainChecklist data-id="element-396" />
      {/* 5. Agitation - chocolate-50 (cream) */}
      <AgitationSection data-id="element-397" />
      {/* 6. Why They Fail - chocolate-900 (dark) */}
      <WhyTheyFail data-id="element-398" />
      {/* 7. Unique Mechanism - white */}
      <UniqueMechanism data-id="element-399" />
      {/* 8. Origin Story - chocolate-50 (cream) */}
      <OriginStory data-id="element-400" />
      {/* 9. Product Presentation - chocolate-900 (dark) */}
      <ProductPresentation data-id="element-401" />
      {/* 10. Value Breakdown - chocolate-50 (cream) */}
      <ValueBreakdown data-id="element-402" />
      {/* 11. Offer Stack + Combos - white */}
      <OfferStack data-id="element-403" />
      {/* 13. Testimonials - chocolate-50 (cream) */}
      <Testimonials data-id="element-404" />
      {/* 15. Guarantee - white */}
      <GuaranteeSection data-id="element-405" />
      {/* 18. FAQ - chocolate-50 (cream) */}
      <FAQSection data-id="element-406" />
      {/* 19. Emotional Close - chocolate-900 (dark) */}
      <EmotionalClose data-id="element-407" />
      {/* Footer - chocolate-900 (dark) */}
      <Footer data-id="element-408" />
      <SocialProofPopup data-id="element-409" />
    </main>;
}